module.exports = __webpack_public_path__ + "img/logo.52b43850.jpg";